import {
    type MembershipIncome,
    type MembershipProfileBillsAnswer,
    type MembershipProfileIncomeAnswer,
    type MembershipProfileSpendingFeelingAnswer,
    type ProfileAnswer,
    QuestionKey,
} from '@fruitful/member-profile';
import React from 'react';
import { YStack } from 'smoothie';

import { MembershipIncomeTable } from '../../../member-profile/components/MembershipIncomeTable';
import { MembershipSavingsInfo } from '../../../member-profile/components/MembershipSavingsInfo';
import { MembershipSpendInfo } from '../../../member-profile/components/MembershipSpendInfo';
import { findMembershipProfileAnswerByQuestionKey } from '../../../member-profile/utils/memberProfileUtils';
import type { MemberDetails, MembershipDetails } from '../../entityTypes';
import { BillsTabPanel } from './MembershipBillsInfo';

export const CashFlowTabPanel = ({
    membershipDetails,
}: {
    membershipDetails: MembershipDetails;
}) => {
    const { users: members, membershipIncomes } = membershipDetails;

    return (
        <YStack gap={24}>
            <IncomeSection
                members={members}
                membershipIncomes={membershipIncomes}
                membershipDetails={membershipDetails}
            />

            <SpendSection membershipDetails={membershipDetails} />

            <SavingsSection membershipDetails={membershipDetails} />

            <BillsSection membershipDetails={membershipDetails} />
        </YStack>
    );
};

const IncomeSection = ({
    members,
    membershipIncomes,
    membershipDetails,
}: {
    members: MemberDetails[];
    membershipIncomes: MembershipIncome[];
    membershipDetails: MembershipDetails;
}) => {
    const incomeAnswer = findMembershipProfileAnswerByQuestionKey<
        ProfileAnswer,
        MembershipProfileIncomeAnswer
    >(membershipDetails.membershipProfileAnswers, QuestionKey.INCOME);

    return (
        <YStack>
            <MembershipIncomeTable
                members={members}
                incomes={membershipIncomes}
                incomeProfileAnswer={incomeAnswer}
            />
        </YStack>
    );
};

const BillsSection = ({
    membershipDetails,
}: {
    membershipDetails: MembershipDetails;
}) => {
    const billsAnswer = findMembershipProfileAnswerByQuestionKey<
        ProfileAnswer,
        MembershipProfileBillsAnswer
    >(membershipDetails.membershipProfileAnswers, QuestionKey.BILLS);

    return (
        <BillsTabPanel
            membershipDetails={membershipDetails}
            billsProfileAnswer={billsAnswer}
        />
    );
};

const SpendSection = ({
    membershipDetails,
}: {
    membershipDetails: MembershipDetails;
}) => {
    const spendingFeelingAnswer = findMembershipProfileAnswerByQuestionKey<
        ProfileAnswer,
        MembershipProfileSpendingFeelingAnswer
    >(membershipDetails.membershipProfileAnswers, QuestionKey.SPENDING_FEELING);

    return (
        <MembershipSpendInfo
            membershipDetails={membershipDetails}
            spendingFeelingAnswer={spendingFeelingAnswer}
        />
    );
};

const SavingsSection = ({
    membershipDetails,
}: {
    membershipDetails: MembershipDetails;
}) => {
    return <MembershipSavingsInfo membershipDetails={membershipDetails} />;
};
